// @flow
import React from 'react';
import { FlexColumn } from 'styles/Layout';
import { LoginDropDownOption } from './styles';
import { hasRoles } from 'modules/dashboards/utils/ValidateRole';

type PropsType = {
  currentUser: any
};

const ExtraList = ({ currentUser }: PropsType) => {
  if (!hasRoles(currentUser, ['finance', 'super_admin'])) {
    return null;
  }
  return (
    <FlexColumn>
      <LoginDropDownOption onClick={() => (window.location.href = '/rentas#/')}>
        Rentas
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/rentas#/pagos-recibidos')}
      >
        Pagos recibidos
      </LoginDropDownOption>
    </FlexColumn>
  );
};

ExtraList.displayName = 'ExtraList';
export default ExtraList;
